import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCustomerPayingWithCard } from '../Selectors'
import { centsToDollars } from '../../utils/formatters'
import { setCustomerPayingWithCard } from '../ActionCreators'

const useStyles = makeStyles(theme => ({
  
}))

export const VNCustomerPayingWithCard = () => {
  const dispatch = useDispatch()
  const dialogOptions = useSelector(state => getCustomerPayingWithCard(state))

  return <VNDialog  open={dialogOptions?.get('open')}
                    subTitle={"Customer Paying {{AMOUNT}} with Card".replace('{{AMOUNT}}', centsToDollars(dialogOptions?.get('amount')))}/>
}
